import type { ReaderTag } from '@/api/client';
import { Switch } from '@/components/ui/Switch/Switch';
import { ReaderCatalogTagPill } from '@/components/ReadersTable/ReaderCatalogTagPill';

export interface ReaderCatalogReaderTagsToggleListProps {
  tags: ReaderTag[];
  assignedIds: Set<string>;
  disabled?: boolean;
  onToggleTag: (tagId: string, on: boolean) => void;
}

export function ReaderCatalogReaderTagsToggleList({
  tags,
  assignedIds,
  disabled = false,
  onToggleTag,
}: ReaderCatalogReaderTagsToggleListProps) {
  return (
    <ul className="reader-catalog-tags-submenu-panel__list" role="list">
      {tags.map((t) => (
        <li key={t.id} className="context-menu__list-item" role="presentation">
          <label className="context-menu__label switch reader-catalog-tags-submenu-panel__switch">
            <Switch
              checked={assignedIds.has(t.id)}
              onCheckedChange={(c) => onToggleTag(t.id, c)}
              disabled={disabled}
              preventFocusScroll
              label={<ReaderCatalogTagPill tag={t} className="reader-catalog-tag--comfortable" />}
            />
          </label>
        </li>
      ))}
    </ul>
  );
}
